import {
  useCreateWireDisbursementMutation,
  useUpdateWireDisbursementMutation,
  useDeleteWireDisbursementMutation,
} from 'API/order/escrow/WireDisbursementAPI';
import {
  convertWireDisbursementDataToCreateWireDisbursement,
  convertWireDisbursementFormDataToUpdateWireDisbursement,
} from './convertWireHelpers';
import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';

export const useProcessWire = () => {
  const [onCreateWire] = useCreateWireDisbursementMutation();
  const [onUpdateWire] = useUpdateWireDisbursementMutation();
  const [onDeleteWire] = useDeleteWireDisbursementMutation();
  return (escrowFileId: string, orderId: string, wireForm: IWireDisbursementFormData) => {
    const { isNew, isDeleting, ...wire } = wireForm;

    if (isNew) {
      return onCreateWire(convertWireDisbursementDataToCreateWireDisbursement(wire, escrowFileId, orderId));
    }
    if (isDeleting) {
      return onDeleteWire({ wireId: wire.id, orderId });
    }
    return onUpdateWire(convertWireDisbursementFormDataToUpdateWireDisbursement(wire, orderId));
  };
};
